import React, { useContext, useEffect } from "react";
import LeftSideBar from "../../components/LeftSideBar";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  Text,
  VStack,
  useDisclosure,
  useMediaQuery,
  Box,
  Link as ChakraLink,
  useToast,
  Image
} from "@chakra-ui/react";
import { AppContext } from "../../context/AppContext";
import Navbar from "../../components/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { FaInstagram, FaTelegram } from 'react-icons/fa';
import InstaImage from '../../assets/Insta.png';
import SelectService from "../../components/SelectService";
import { MdOutlineSupportAgent } from "react-icons/md";
const Home = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { balance, defaultServer, } = useContext(AppContext);
  const location = useLocation();
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");

  return (
    <VStack w={"100%"}>
      <Navbar onOpen={onOpen} />
      <HStack
        align={"start"}
        mt={"0 !important"}
        minH={"100%"}
        justify={"start"}
        w={"100%"}
      >
        {isLargerThan992 ? <LeftSideBar /> : <></>}
        {location.pathname == "/" && <SelectService server={Number(defaultServer?.replace(/\D/g, ""))} />}
        <Drawer
          placement={"left"}
          onClose={onClose}
          isOpen={isOpen}
          size={["xs", "sm", "md", "md"]}
        >
          <DrawerOverlay />
          <DrawerContent bgColor={"#EDF2F8"} borderTop={"4px solid rgb(220, 20, 60)"}>
            <DrawerCloseButton color={"white"} />
            <DrawerHeader
              bgColor={"rgb(229, 60, 94)"}
              borderBottomWidth="2px"
              borderBottomColor="rgb(200, 40, 70)"
              color={"white"}
              fontWeight={700}
              fontSize={"1.1rem"}
            >
              Balance{" "}
              <span style={{ fontSize: "1rem", color: "white", background: "rgba(0,0,0,0.18)", padding: "0.1rem 0.5rem", borderRadius: "6px" }}>
                ₹{Number(balance).toFixed(1)}
              </span>
            </DrawerHeader>
            <DrawerBody>
              <LeftSideBar closeDrawer={onClose} status={true} />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        {/* <Box zIndex={10} position={'fixed'} bottom={['6.8rem', '7.2rem', '7.3rem', '7.3rem']} right={['0.5rem', '0.9rem', '1rem', '1rem']} fontSize={'3rem'} >
        <ChakraLink href="https://www.instagram.com/durgeshsingh_ctrader?igsh=dW5penI1bjA4OGVv&utm_source=qr" target={"_blank"}>
              <FaInstagram style={{
                color: '#DD2A7B',
                cursor: 'pointer'
              }} />
            </ChakraLink>
        </Box>
         <Box zIndex={10} position={'fixed'} bottom={['3.8rem', '4.2rem', '4.3rem', '4.3rem']} right={['0.5rem', '0.9rem', '1rem', '1rem']} fontSize={'3rem'} >
         <ChakraLink href=" https://youtube.com/@durgeshsingh_ctrader?si=rIOdW463c1xy7dzn" target={"_blank"}>
                <BsYoutube style={{
                  color: '#CD201F',
                  cursor: 'pointer'
                }} />
              </ChakraLink>
        </Box> */}
        {/* <Box zIndex={10} position={'fixed'} bottom={['3.8rem', '4.2rem', '4.3rem', '4.3rem']} right={['0.5rem', '0.9rem', '1rem', '1rem']} fontSize={'3rem'} >
          <ChakraLink href="https://www.instagram.com/durgeshsingh_ctrader?igsh=dW5penI1bjA4OGVv&utm_source=qr" target={"_blank"}>
            <Image
              w={["7rem", "9rem"]}
              src={InstaImage}
            />
          </ChakraLink>
        </Box> */}
        <Box zIndex={10} position={'fixed'} p={'0.3rem'} rounded={'full'} bgColor={'#3390EC'} bottom={['3.8rem', '4.2rem', '4.3rem', '4.3rem']} right={['0.5rem', '0.9rem', '1rem', '1rem']} fontSize={'2.5rem'} >
          <ChakraLink href="https://wa.me/919560716681" target={"_blank"}>
            <MdOutlineSupportAgent style={{
              color: 'white',
              cursor: 'pointer'
            }} />
          </ChakraLink>
        </Box>
        <Box zIndex={10} position={'fixed'} bottom={['0.5rem', '0.9rem', '1rem', '1rem']} right={['0.5rem', '0.9rem', '1rem', '1rem']} fontSize={'3rem'} >
          <ChakraLink href="https://telegram.me/dailynewupdatepro" target={"_blank"}>
            <FaTelegram style={{
              color: '#3390EC',
              cursor: 'pointer'
            }} />
          </ChakraLink>
        </Box>
        <Outlet />
      </HStack>
    </VStack>
  );
};

export default Home;
